import { render, staticRenderFns } from "./Acordos.vue?vue&type=template&id=60f0843a&scoped=true"
import script from "./Acordos.vue?vue&type=script&lang=js"
export * from "./Acordos.vue?vue&type=script&lang=js"
import style0 from "./Acordos.vue?vue&type=style&index=0&id=60f0843a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0843a",
  null
  
)

export default component.exports